import { useState } from "react";
import API from "../../services/API";
import { IconButton, LinearProgress, Paper, Stack, Typography, Chip } from "@mui/material";
import { Delete, Edit } from "@mui/icons-material";

export default function Product({data, onDelete, onEdit}){

    const [deleting, setDeleting] = useState(false)

    const handleDelete = () => {

        const ok = window.confirm("Êtes-vous sûr de vouloir supprimer ce tarif ?");

        if(!ok) return false;

        setDeleting(true)

        API.delete(`/products/${data.id}`)
            .then(_ => onDelete(data.id))
            .catch(e => console.error(e))
            .finally(() => setDeleting(false))
    }

    return <Paper variant='outlined' >

        <Stack>

            {deleting && 
                <LinearProgress color='error' />
            }

            <Stack direction='row' justifyContent='space-between' alignItems='center' flexWrap='wrap' spacing={1} sx={{p: 2}}>

                <Typography>
                    {data.title}
                        
                    {data.stock && <>

                        <br/>

                        <small>{data.stock?.available} places disponibles sur {data.stock?.initial}</small>
                        
                    </>}
                </Typography>


                <Stack spacing={1} direction='row' alignItems='center'>

                    <Chip 
                        label={data.price.toLocaleString() + '€'}
                        color='primary'
                    />

                    <IconButton onClick={onEdit} disabled={deleting}>
                        <Edit />
                    </IconButton>

                    <IconButton onClick={handleDelete} disabled={deleting}>
                        <Delete />
                    </IconButton>

                </Stack>

            </Stack>

        </Stack>

    </Paper>
}